__turbopack_context__.v({
  "arrow": "CoreFeaturedVideo-module-scss-module__eaYutG__arrow",
  "content": "CoreFeaturedVideo-module-scss-module__eaYutG__content",
  "ctas": "CoreFeaturedVideo-module-scss-module__eaYutG__ctas",
  "main": "CoreFeaturedVideo-module-scss-module__eaYutG__main",
  "name": "CoreFeaturedVideo-module-scss-module__eaYutG__name",
  "side-by-side": "CoreFeaturedVideo-module-scss-module__eaYutG__side-by-side",
  "transcript": "CoreFeaturedVideo-module-scss-module__eaYutG__transcript",
  "video-description": "CoreFeaturedVideo-module-scss-module__eaYutG__video-description",
  "video-player": "CoreFeaturedVideo-module-scss-module__eaYutG__video-player",
});
